@if (
  isNotAuthorized$ | async) {
  <app-not-authorized />
} @else {
  <ng-template [ngTemplateOutlet]="(isFatalError$ | async) ? fatalError : shell" />
}

<ng-template #shell>
  <app-shell>
    @if (!(isCompactMode$ | async)) {
      <app-topbar topbar>
        <app-breadcrumb />
        <app-user-topbar-section (avatarClicked)="openRightPanel()" />
      </app-topbar>
    }

    @if (!(isCompactMode$ | async)) {
      <app-main-menu left-sidenav />
    }

    <ng-container right-sidenav>
      <app-user-panel>
        <app-user-menu additional-content />
      </app-user-panel>
    </ng-container>

    <ng-container main-content>
      <router-outlet />
    </ng-container>
  </app-shell>
</ng-template>


<ng-template #fatalError>
  <app-fatal-errors />
</ng-template>

<app-busy-indicator />
